import React from "react";

/**
 * Shared star rating control (Vendor list/table/detail).
 * @param {{ value?: number, onChange?: (n: number) => void, readOnly?: boolean, size?: 'small'|'normal' }} props
 */
export default function StarRating({ value, onChange, readOnly = false, size = "normal" }) {
  const v = value >= 1 && value <= 5 ? value : 0;
  const fontSize = size === "small" ? "0.95rem" : "1.1rem";
  return (
    <span style={{ display: "inline-flex", gap: "2px", flexShrink: 0 }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && onChange && onChange(star)}
          onKeyDown={(e) => {
            if (readOnly || !onChange) return;
            if (e.key === "Enter" || e.key === " ") onChange(star);
          }}
          style={{
            padding: 0,
            border: "none",
            background: "none",
            cursor: readOnly ? "default" : "pointer",
            fontSize,
            lineHeight: 1,
            color: star <= v ? "#f0ad4e" : "#ddd",
            flexShrink: 0,
          }}
          aria-label={`${star} star${star > 1 ? "s" : ""}`}
        >
          {star <= v ? "★" : "☆"}
        </button>
      ))}
    </span>
  );
}
